import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-input-filled p-formgrid p-grid p-pb-2 p-px-2" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-field p-col-12" }
const _hoisted_4 = { for: "password" }
const _hoisted_5 = { class: "p-field p-col-12" }
const _hoisted_6 = { for: "passwordRepeat" }
const _hoisted_7 = { class: "p-col-12 p-mt-2" }
const _hoisted_8 = { class: "p-col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('Squeeze.Login.ResetPasswordInfoText')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('Squeeze.Login.Password')), 1),
      _withDirectives(_createVNode(_component_Password, {
        id: "password",
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
        modelModifiers: { trim: true },
        class: _normalizeClass({'p-invalid': _ctx.showErrorMandatory || _ctx.showErrorPasswordLength || _ctx.showErrorMinOneLowerAndUpperCase || _ctx.showErrorAtLeastOneNumber || _ctx.showErrorOneSpecialCharacter}),
        onChange: _ctx.onChangeField,
        feedback: false,
        onKeydown: _ctx.onKeyDown,
        toggleMask: "",
        autofocus: ""
      }, null, 8, ["modelValue", "class", "onChange", "onKeydown"]), [
        [
          _directive_tooltip,
          _ctx.passwordValidationRules,
          void 0,
          { bottom: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Squeeze.Login.PasswordRepeat')), 1),
      _createVNode(_component_Password, {
        id: "passwordRepeat",
        modelValue: _ctx.passwordRepeat,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordRepeat) = $event)),
        modelModifiers: { trim: true },
        class: _normalizeClass({'p-invalid': _ctx.showErrorMandatory || _ctx.showErrorEqual}),
        feedback: false,
        onChange: _ctx.onChangeField,
        onKeydown: _ctx.onKeyDown,
        toggleMask: ""
      }, null, 8, ["modelValue", "class", "onChange", "onKeydown"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Button, {
        loading: _ctx.loading,
        label: _ctx.$t('Squeeze.Login.Send'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickSend()))
      }, null, 8, ["loading", "label"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.showErrorMandatory
				|| _ctx.showErrorEqual
				|| _ctx.showErrorPasswordLength
				|| _ctx.showErrorMinOneLowerAndUpperCase
				|| _ctx.showErrorAtLeastOneNumber
				|| _ctx.showErrorOneSpecialCharacter)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            severity: "error",
            closable: false
          }, {
            default: _withCtx(() => [
              (_ctx.showErrorMandatory)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.Login.MandatoryPasswords')) + " ", 1),
                    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.showErrorEqual)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.Login.PasswordsMustBeEqual')) + " ", 1),
                    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1))
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.showErrorPasswordLength)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.PasswordLength')) + " ", 1),
                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.showErrorMinOneLowerAndUpperCase)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.MinOneLowerAndUpperCase', { field: _ctx.$t('Squeeze.Login.Password')})) + " ", 1),
                    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1))
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.showErrorAtLeastOneNumber)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.AtLeastOneNumber', { field: _ctx.$t('Squeeze.Login.Password')})) + " ", 1),
                    _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1))
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.showErrorOneSpecialCharacter)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Forms.Val.AtLeastOneSpecialCharacter', { field: _ctx.$t('Squeeze.Login.Password')})) + " ", 1),
                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}